function fn_part_wsw() {
    var part_wsw = ".wsw";
    if ($(part_wsw).length) {
        $(part_wsw).each(function () {
            var wsw = $(this);
            wsw.find("table").each(function () {
                $(this).wrap("<div class=\"table\"></div>")
            })
        })
    }
}